module.exports = __webpack_public_path__ + "img/logo-icon.4bd5443d.png";